import { api } from '@/config/api';

export interface MetaCustomAudience {
  audienceUid: string; companyUid: string;
  metaAudienceId: string;
  name: string; description?: string;
  sourceGroupUid?: string;
  lastSyncedRecipientCount: number;
  lastSyncedAt?: string;
  lastSyncStatus?: string;
  lastSyncError?: string;
  approximateCount?: number;
  metaSubtype?: string;
  deliveryStatus?: string;
  operationStatus?: string;
  metaName?: string;
  createdAt: string;
}

export interface AudiencesListResponse {
  items: MetaCustomAudience[];
  fetchedAt: string;
  fromCache: boolean;
}

export interface BuildFromWonPayload {
  sinceDays?: number;
  name?: string;
}

export interface BuildLookalikeFromWonPayload {
  sinceDays?: number;
  country?: string;
  ratio?: number;
  name?: string;
}

export interface BuildFromWonResult {
  audienceUid: string;
  metaAudienceId: string;
  recipientCount: number;
}

export interface BuildLookalikeFromWonResult {
  source: BuildFromWonResult;
  lookalike: { audienceUid: string; metaAudienceId: string };
}

export interface CreateLookalikePayload {
  source_audience_id: string;
  country: string;
  /** 0.01 – 0.20 (1%–20% of the country's Facebook population). */
  ratio: number;
  name?: string;
  description?: string;
}

export interface CreateLookalikeResult {
  audienceUid: string;
  metaAudienceId: string;
}

export const facebookAudiencesService = {
  list: async (refresh = false): Promise<AudiencesListResponse> =>
    (await api.get('/slighter_crm/facebook/audiences', { params: { refresh: refresh ? '1' : undefined } })).data,
  syncFromGroup: async (payload: { groupUid: string; name?: string; description?: string }) =>
    (await api.post('/slighter_crm/facebook/audiences/sync-from-group', payload)).data as { audienceUid: string; metaAudienceId: string; recipientCount: number },
  remove: async (audienceUid: string) => { await api.delete(`/slighter_crm/facebook/audiences/${audienceUid}`); },
  buildFromWonLeads: async (payload: BuildFromWonPayload): Promise<BuildFromWonResult> =>
    (await api.post('/slighter_crm/audiences/from-won-leads', payload)).data,
  buildLookalikeFromWon: async (payload: BuildLookalikeFromWonPayload): Promise<BuildLookalikeFromWonResult> =>
    (await api.post('/slighter_crm/audiences/lookalike-from-won', payload)).data,

  /** Build a lookalike from any existing custom audience as the seed. */
  createLookalike: async (payload: CreateLookalikePayload): Promise<CreateLookalikeResult> =>
    (await api.post('/slighter_crm/facebook/audiences/lookalike', payload)).data,
};
